import styled from 'styled-components';
import BellIcon from './BellIcon';
import {
  CustomButton,
  FlexContainer,
  TileTitle
} from '../NarrowSaveTile.styles';

export const CustomFlexContainer = styled(FlexContainer)`
  background: #fff;
  box-shadow: 1px 1.7px 2.9px rgba(25, 41, 61, 0.18);
  height: 100%;
  padding: 24px;

  @media (min-width: 768px) {
    padding: 24px 35px;
  }
`;

export const CustomPrimaryButton = styled(CustomButton)`
  background-color: ${props => props.theme.carvana.blue.primary};
  border: 0;
  color: #fff;
  font-weight: bold;
  line-height: 20px;
  margin: 0;
  text-transform: uppercase;
  transition: opacity 0.5s linear;
  width: 100%;
  height: 40px;
`;

export const FlexPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    text-align: left;
  }
  @media (min-width: 768px) {
    flex-direction: column;

    div {
      text-align: center;
    }
  }
`;

export const TextAndIconPanel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (min-width: 768px) {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

export const FullWidthFlexPanel = styled(FlexPanel)`
  width: 100%;
`;

export const CustomIcon = styled(BellIcon)`
  margin-bottom: 12px;
  margin-right: 14px;
  min-width: 54px;

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const CustomTileTitle = styled(TileTitle)`
  font-size: 16px;
  font-weight: bold;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 26px;
    line-height: 28px;
    margin-bottom: 12px;
    white-space: pre-line;
  }
`;
